import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import MarketsFull from './markets-full'

const MarketsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <MarketsFull {...props}/>
    </QueryClientProvider>
  );
};

export { MarketsFullWidget }
